'use client'
import { cx } from '../utils'

export function StatCard({
  label,
  value,
  delta,
  tone,
  hint,
}: {
  label: string
  value: string | number
  delta?: string
  tone?: 'ok' | 'warn' | 'danger' | 'info'
  hint?: string
}) {
  const toneClass = tone === 'ok' ? 'text-ok' : tone === 'warn' ? 'text-warn' : tone === 'danger' ? 'text-danger' : 'text-info'
  return (
    <div className="rounded-sm border border-line bg-surface px-5 py-4 shadow-[var(--shadow-xs)]">
      <p className="text-[13px] font-medium tracking-[0.08em] text-ink-3 uppercase">{label}</p>
      <p className="mt-2 text-[26px] font-semibold leading-none tracking-[-0.02em] text-ink">{value}</p>
      {(delta || hint) && (
        <p className={cx('mt-1.5 text-[13px]', delta && tone ? toneClass : 'text-ink-3')}>
          {delta ?? hint}
        </p>
      )}
    </div>
  )
}
